import { render, staticRenderFns } from "./repairedHandle.vue?vue&type=template&id=b2dbab58&scoped=true&"
import script from "./repairedHandle.vue?vue&type=script&lang=js&"
export * from "./repairedHandle.vue?vue&type=script&lang=js&"
import style0 from "./repairedHandle.vue?vue&type=style&index=0&id=b2dbab58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dbab58",
  null
  
)

export default component.exports